import { render, staticRenderFns } from "./AiReferrerDropdown.vue?vue&type=template&id=0e45d372&scoped=true"
import script from "./AiReferrerDropdown.vue?vue&type=script&lang=js"
export * from "./AiReferrerDropdown.vue?vue&type=script&lang=js"
import style0 from "./AiReferrerDropdown.vue?vue&type=style&index=0&id=0e45d372&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e45d372",
  null
  
)

export default component.exports